import { type App, type Ref, createApp, reactive, ref } from "vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { initializeCPWidgetBannerAnalytics } from "@/shared/utils/analytics/analytics-cp-widget-banner";
import ContestForm from "../widgets/components/contest-form.vue";
import { ContestFormConfiguration } from "../widgets/models/contest-form-models";

const showContestForm = async (identifier?: number) => {
    Loader.show();
    const configurationResponse = await httpClient.get<ContestFormConfiguration>("/api/landing-page/contest-form", {
        params: {
            identifier,
        },
    });
    const props = reactive({
        configuration: configurationResponse.data,
        identifier: identifier,
    });

    const alertRef: Ref<App> = ref(null);

    alertRef.value = createApp(ContestForm, props);

    const root = document.createElement("div");
    alertRef.value.mount(root);
    Loader.hide();
};

(window as any).openFormContest = (identifier?: number) => {
    showContestForm(identifier);
};

document.ready(() => {
    initializeCPWidgetBannerAnalytics();
});
